const lowercaseKeys = (obj: any): any => {
  const entries = Object.entries(obj);

  return Object.fromEntries(entries.map(([key, value]) => [key.toLowerCase(), value]));
};

export const getTempTokenFromURL = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const paramsObject = Object.fromEntries(urlParams.entries());
  const newParamsObject = lowercaseKeys(paramsObject);

  const { token } = newParamsObject;

  const tempToken = token;

  return tempToken;
};

export const getPathFromURL = (index: number): string => window.location.pathname.split('/')[index];

export const decodeURL = (url: string): string => decodeURIComponent(url);

export const endpointsForSuccessModal = ['/restart', '/versions'];

export const CASH_REGISTER_URL = '/cash-register';

export const HEALTH_MONITOR_URL = '/health-monitor';

export const HEALTH_MONITOR_DETAILS_URL = '/health-monitor/';